import { RouterProvider } from 'react-router-dom';
import router from './routes';
import Locales from './components/Locales';
import HintTooltip from './components/common/HintTooltip/HintTooltip';

function App() {
  return (
    <Locales>
      <RouterProvider router={router} />
      <HintTooltip />
    </Locales>
  );
}

export default App;
